import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseCloseGuide.module.scss'

const cx = className.bind(style)

const MyhouseCloseGuide: React.FC = () => {
  return (
    <>
      <h3 className={cx('title')}>서비스 해지에 앞서 아래 사항을 반드시 확인하시기 바랍니다.</h3>
      <div className={cx('guide')}>
        <strong className={cx('subtitle')}>서비스 해지 안내사항</strong>
        <p className={cx('text')}>
          서비스 해지 시 약관이 모두 철회되며 우리집 등록 시에 입력한 정보가 모두 삭제됩니다.
          <br />본 서비스 해지 후에도 네이버 파이낸셜의 회원 자격은 유지되며, 네이버 파이낸셜의 다른 서비스 이용에는 영향이 없습니다. 서비스 해지 후 약관에 재동의 하실 경우 이전
          서비스 이용 내역에 대한 복구는 불가합니다.
        </p>
      </div>
      <div className={cx('guide')}>
        <strong className={cx('subtitle')}>서비스 해지하기</strong>
        <p className={cx('text')}>
          우리집 등록 서비스 이용 시 동의한 약관 철회 및 등록한 우리집 정보 삭제에 동의합니다.
          <br />
          단, 서비스 해지 후에도 공지사항 및 입주민리뷰에 등록한 게시물은 그대로 남아 있습니다. 삭제를 원하는 게시글이 있다면 반드시 해지 전 삭제하시기 바랍니다.
        </p>
      </div>
    </>
  )
}

export default MyhouseCloseGuide
